import React, { createContext, useState, useEffect, useContext } from 'react';
import sitesApi from '../services/sitesApi';

const SiteAuthContext = createContext(null);

export const useSiteAuth = () => useContext(SiteAuthContext);

export const SiteAuthProvider = ({ children }) => {
    const [siteUser, setSiteUser] = useState(null);
    const [siteToken, setSiteToken] = useState(localStorage.getItem('site_token'));
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const initAuth = async () => {
            if (siteToken) {
                try {
                    const res = await sitesApi.getProfile();
                    setSiteUser(res.data.user || res.data);
                } catch (err) {
                    console.error('Failed to authenticate site user:', err);
                    setSiteToken(null);
                    sitesApi.setToken(null);
                }
            }
            setLoading(false);
        };
        initAuth();
    }, [siteToken]);

    const siteLogin = async (credentials) => {
        const res = await sitesApi.login(credentials);
        const { token, user } = res.data;
        setSiteToken(token);
        sitesApi.setToken(token);
        setSiteUser(user);
        return user;
    };

    const siteRegister = async (userData) => {
        const res = await sitesApi.register(userData);
        const { token, user } = res.data;
        setSiteToken(token);
        sitesApi.setToken(token);
        setSiteUser(user);
        return user;
    };

    const siteLogout = () => {
        setSiteToken(null);
        setSiteUser(null);
        sitesApi.setToken(null);
    };

    const value = {
        siteUser,
        siteToken,
        loading,
        siteLogin,
        siteRegister,
        siteLogout
    };

    return (
        <SiteAuthContext.Provider value={value}>
            {children}
        </SiteAuthContext.Provider>
    );
};
